import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import 'moment/locale/zh-cn';
import 'moment/locale/zh-hk';

import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, Subject } from 'rxjs';
import { Translate, _common as __common } from './_common';
import { AppConfig } from './common/app.config';
import { WebUtils } from './common/utils';
import {
  AccessUtils,
  TLocation,
  TMember,
  TOrganization,
  TSpaceFacility,
  TSpaceType,
} from './core/entities';
import { SessionCache } from './session.cache';
import { Thinkdesks, ThinkdesksTimeMode } from './thinkdesks/thinkdesks';
import { QRCodeDialog } from './user/qrcode.dialog';

export let TIMEZONE = 'Asia/Hong_Kong';
export let CONTENT_PATH = '/site_content';
export let GOOGLE_MAP_APIKEY = 'AIzaSyCISVKAK2YPCrXd1JDjg3FCsaY9M-yCECA';
export const PASSWORD_LENGTH = 6;
export const PASSWORD_PATTERN = 'Aa0';
export const DEBUG = window.location.host != 'booking.jc21c.net';
@Injectable()
export class SessionService {
  embedded = false;

  user: TMember;
  userStream = new BehaviorSubject(null);
  organizations: TOrganization[];
  locations: TLocation[];

  lang: string = 'zh_hk';
  langStream = new Subject();
  constructor(
    private snackBar: MatSnackBar,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private cache: SessionCache
  ) { }
  async init() {
    let lang = this.route.snapshot.queryParamMap.get('lang');
    lang ??= 'zh_hk';
    if (lang != 'zh_hk' && lang != 'en') {
      lang = 'zh_hk';
    }
    this.lang = lang;
    AppConfig.appConfig = (window as any).appConfig;

    // Thinkdesks customization

    Thinkdesks.init(30, {
      timeFormat: 'hh:mmA',
      timeMode: ThinkdesksTimeMode.start,
    });

    await this.refresh();
    this.getLocation();

    // let ss = new ScriptService();
    // await ss.load(`nls/${this.locale}/_common.js`);
    this.changeLocale(this.user?.locale ?? this.lang);
  }
  terms: any;
  loadTerms() {
    return new Promise((resolve, reject) => {
      if (this.terms) {
        resolve(this.terms);
        return;
      }
      WebUtils.web_result(
        this.http.get('/api/systerms'),
        (result) => {
          this.terms = result;
          resolve(this.terms);
        },
        null,
        (err) => reject(err)
      );
    });
  }

  locationStream = new BehaviorSubject(null);
  // locationLoaded = false;
  location: {
    lat: number;
    lng: number;
  };
  getLocation(): void {
    // this.locationLoaded = true;

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // this.locationLoaded = true;

          const lng = position.coords.longitude;
          const lat = position.coords.latitude;
          // this.location = {
          //   lng,
          //   lat,
          // };
          this.locationStream.next({
            lng,
            lat,
          });
        },
        () => {
          // this.locationLoaded = true;
        }
      );
    } else {
      // this.locationLoaded = true;
      console.log('No support for geolocation');
    }
  }
  refresh() {
    return new Promise((resolve, reject) => {
      WebUtils.web_result(
        this.http.get('/api/session'),
        (result) => {
          this.setUser(result.user);

          let spaceTypes = result.spaceTypes as TSpaceType[];
          for (let o of spaceTypes) AccessUtils.fixSpaceType(o);
          this.cache.spaceTypes = spaceTypes;

          let spaceFacilities = result.spaceFacilities as TSpaceFacility[];
          for (let o of spaceFacilities) AccessUtils.fixSpaceFacility(o);
          // this.cache.spaceFacilities = spaceFacilities;

          resolve(null);
        },
        null,
        (err) => reject(err)
      );
    });
  }

  setUser(user: TMember) {
    if (user) {
      AccessUtils.fixMember(user);
    }
    this.user = user;

    this.userStream.next(this.user);
    this.locations = this.user?.locations ?? [];
  }

  vpLogin(authCode: string, cb?: () => void) {
    this.embedded = true;
    WebUtils.web_result(
      this.http.post('/vp-validate', { authCode }),
      async (result) => {
        let member = result;
        // this.snackBar.open(JSON.stringify(result));

        await this.refresh();
        if (cb) {
          cb();
        }
      },
      this.snackBar,
      (error) => {
        this.router.navigate(['/sso-error']);
      }
    );
  }
  login() {
    window.location.href = '/authorize';

    // this.router.navigate([this.path('/login')]);
  }
  logout() {
    // window.location.href='/logout'
    WebUtils.web_result(this.http.get(`/logout`), (result) => {
      this.setUser(null);
      this.embedded = false;
      if (result.url) {
        let url = result.url
        url += encodeURIComponent(window.location.origin + `/${this.lang}/home`);
        window.location.href = url

      } else {
        this.router.navigate([this.path('/')]);
      }
    });
  }
  changeLocale(lang: string) {
    this.lang = lang;
    if (Translate[lang])
      Object.assign(__common, Object.assign({}, Translate[lang]));
    else Object.assign(__common, Object.assign({}, Translate.en));

    this.langStream.next(lang);
    _common = __common;
  }
  path(p: string) {
    return `/${this.lang}${p}`;
  }

  hasPermission(p: string) {
    let user = this.user;
    if (!user?.memberType) return false;
    return user.memberType.permissions.includes(p);
  }
  hasPermissions(list: string[]) {
    let user = this.user;
    if (!user?.memberType) return false;
    for (let p of list) {
      if (user.memberType.permissions.includes(p)) return true;
    }
    return false;
  }
  hasLocation(id: number) {
    if (!this.user) return false;
    return !!this.user.locations.find((c) => c.id == id);
  }
  mergeQuery(query: any) {
    let list = query.locations;
    let qq = this.userQuery();
    Object.assign(query, qq);

    if (list.length) {
      let l = [];
      for (let s of list) {
        let ss = parseInt(s);
        if (qq.locations.includes(ss)) {
          l.push(s);
        }
      }
      if (!l.length) {
        l = [-1];
      }
      query.locations = l

    }

  }
  userQuery() {
    if (!this.user?.locations.length) {
      return {
        locations: [-1],
      };
    }

    return {
      locations: this.user.locations.map((c) => c.id),
    };
  }
  setTitle(title?: string) {
    let _title = document.getElementById('_title') as HTMLMetaElement;
    _title.innerHTML = title ?? '21c';
  }
  showQrCode(opts: { router: Router; dialog: MatDialog }) {
    opts.dialog.open(QRCodeDialog, {});
    // this.router.navigate(['/my/qrcode'])
  }
}
